import { AUTH_BANNER_CONFIG } from "../../../lib/authBanners";
import { useLocationStateBanner } from "../../../hooks/useLocationStateBanner";

export function useLocationBanner() {
  return useLocationStateBanner({
    config: AUTH_BANNER_CONFIG,
    stateKey: "bannerReason",
  });
}
